import {useState} from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import CircledIcon from '../../../components/CircledIcon';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import GenericCard from '../../../components/GenericCards/GenericCards';
import Label from '../../../components/Label/Label';
import IconButton from '../../../components/IconButton';
import PopoverWithLinks from '../../widgets/PopoverLinks/PopoverLinks';
import Blockquote from '../../../components/Blockquote';
const AllBenefits = () => {
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [showDetails2, setShowDetails2] = useState<boolean>(false);
  const [showDetails3, setShowDetails3] = useState<boolean>(false);
  const [showDetails4, setShowDetails4] = useState<boolean>(false);
  const [showDetails5, setShowDetails5] = useState<boolean>(false);
  const [showDetails6, setShowDetails6] = useState<boolean>(false);
  const [showDetails7, setShowDetails7] = useState<boolean>(false);
  const [showDetails8, setShowDetails8] = useState<boolean>(false);
  const [showDetails9, setShowDetails9] = useState<boolean>(false);
  const [showDetails10, setShowDetails10] = useState<boolean>(false);
  const [showDetails11, setShowDetails11] = useState<boolean>(false);
  const toggleDetails = () => {
    setShowDetails(!showDetails);
  };
  const toggleDetails2 = () => {
    setShowDetails2(!showDetails2);
  };

  const toggleDetails3 = () => {
    setShowDetails3(!showDetails3);
  };

  const toggleDetails4 = () => {
    setShowDetails4(!showDetails4);
  };
  const toggleDetails5 = () => {
    setShowDetails5(!showDetails5);
  };
  const toggleDetails6 = () => {
    setShowDetails6(!showDetails6);
  };
  const toggleDetails7 = () => {
    setShowDetails7(!showDetails7);
  };
  const toggleDetails8 = () => {
    setShowDetails8(!showDetails8);
  };

  const toggleDetails9 = () => {
    setShowDetails9(!showDetails9);
  };
  const toggleDetails10 = () => {
    setShowDetails10(!showDetails10);
  };
  const toggleDetails11 = () => {
    setShowDetails11(!showDetails11);
  };
  return (
    <Container className={'px-0'}>
      <Row className={'mt-8'}>
          <Col className={'col-12 col-lg-6'}>
              <h6 className="text-20 pb-0 mb-0">Health Benefits</h6>
          </Col>
      </Row>
      <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <CircledIcon
                  icon={light('heart-pulse')}
                  iconClassName="left-icon"
                  variant="icon-emphasized"
                />
              
              <div className="ms-4">
                <h5>Medical</h5>
              </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <IconButton
                  variant="secondary-shadow"
                  icon={light('circle-info')}
                  onMouseDown={toggleDetails}
                  style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                />
                <Label
                  className="d-none d-lg-flex px-4"
                  style={{ color: '#54626A', cursor: 'pointer' }}
                  onMouseDown={toggleDetails}
                >
                  Benefits Info
                </Label>
              </div>
            </div>
            <Container className={'px-0 py-0 mt-10'}>
            <Row className={`expandable-wrapper ${showDetails ? 'open' : ''}`}>
              <div className="w-100 justify-content-center">

              <Card
                bg={'blue'}
                key={'Primary'}
                text={'white'}
                style={{ width: '18rem' }}
                className="bg-primary w-100 mb-12"
              >
                <Card.Body>
                  <Card.Text>
                    <ul>
                      <li>Your medical election includes prescription drug coverage.</li>
                      <li>If you are an active employee eligible for TRICARE due to military or prior military service, you may wish to consider the TRICARE Military Supplement Plan Option (based on your eligibility for this option). To learn more about the TRICARE Military Supplement Plan Option, go to the TRICARE Military Supplement Plan Option website at https://info.selmanco.com/delta-airlines.  IMPORTANT NOTE: If you access this site while making your medical coverage elections on Benefits Direct, your enrollment session may time-out after 10 minutes. You should save all Benefits Direct enrollment elections by selecting the “Submit” button before accessing the TRICARE Military Supplement website. You may also click here for additional information about this medical option.</li>

                    </ul>

                  </Card.Text>
                </Card.Body>
              </Card>

              </div>
             </Row>
              {/* Table head */}
              <Row className={'d-none d-lg-flex mt-0 pb-2'}>
              <Col lg={7} className="py-5"></Col>
              <Col lg={5} className="py-5">Per-pay-period</Col>
              </Row>
              <Row className={'d-none d-lg-flex mt-0 pb-5 pt-5 border-bottom-light-gray-2px'}>
                <Col lg={4}>
                  <div className={'d-flex align-items-center'}>Medical</div>
                </Col>                
                <Col lg={1}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={1} className="text-center">
                  You Only
                </Col>
                <Col lg={2} className="text-center">
                  You + Spouse
                </Col>
                <Col lg={2} className="text-center">
                  You + Child(ren)
                </Col>
                <Col lg={2} className="text-center">
                  You + Family
                </Col>
 
              </Row>

              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Copay Option</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $77.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $167.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $136.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $225.00
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Gold HSA</span></div></div>
                </Col>
                <Col lg={1} className="text-end py-5">
                <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $59.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $128.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $104.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $172.50
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Silver HSA</span></div></div>
                 </Col>
                <Col lg={1} className="text-end py-5">
                <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $21.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $46.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $37.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $61.50
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Delta Pilots - High Deductible Health Plan</span></div></div>
                </Col>
                <Col lg={1} className="text-end py-5">
                <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>              
                <Col lg={1} className="text-center py-10">
                    $59.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $128.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $104.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $173.00
                </Col> 
              </Row>
 

              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Delta Pilots Medical Plan</span></div></div>
                </Col>
                <Col lg={1} className="text-end py-5">
                <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>              
                <Col lg={1} className="text-center py-10">
                    $77.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $167.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $136.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $225.00
                </Col> 
              </Row>

              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>No Coverage</span></div></div>
                </Col>
                <Col lg={1} className="text-end py-5">
                
                
                </Col>              
                <Col lg={1} className="text-center py-10">
                $0.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    
                </Col>
                <Col lg={2} className="text-center py-10">
                    
                </Col>
                <Col lg={2} className="text-center py-10">
                     
                </Col> 
              </Row>


            </Container> 
          </GenericCard>
        </Col>
      </Row>


      <Container className={'px-0 py-0 mt-10'}>
      <Row className={'mt-0'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <CircledIcon
                  icon={light('heart-pulse')}
                  iconClassName="left-icon"
                  variant="icon-emphasized"
                />
              
              <div className="ms-4">
                <h5>Health Savings Account</h5>
              </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <IconButton
                  variant="secondary-shadow"
                  icon={light('circle-info')}
                  onMouseDown={toggleDetails2}
                  style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                />
                <Label
                  className="d-none d-lg-flex px-4"
                  style={{ color: '#54626A', cursor: 'pointer' }}
                  onMouseDown={toggleDetails2}
                >
                  Benefits Info
                </Label>


                

              </div>
            </div>
            <Row className={`expandable-wrapper mt-10 ${showDetails2 ? 'open' : ''}`}>
              <div className="w-100 justify-content-center">

              <Card
                bg={'blue'}
                key={'Primary'}
                text={'white'}
                style={{ width: '18rem' }}
                className="bg-primary w-100 mb-12"
              >
                <Card.Body>
                  <Card.Text>
                    <ul>
                      <li>If you elect a high deductible medical option, it features access to an individual health savings account through Optum Bank that may be funded with your pre-tax payroll deductions if you are on active payroll status. You must have an open HSA Account with Optum Bank to have pre-tax payroll deductions and Delta contributions (Delta Health Rewards and child funding) deposited to your account.</li>
                      <li>Your payroll deductions, Delta Health Rewards, child funding (if applicable) and direct deposits together should not exceed your maximum allowed contribution for the year ($4,300 for employee coverage or $8,550 for family coverage in 2025 plus an additional $1,000 catch-up contribution if you are age 55 or older).
                      Refer to www.irs.gov and Publication 969 for more information on determining your annual maximum. For additional information and answers to many HSA-related questions, click here.</li>
                      <li>If you are active and 65, click here.</li>
                    </ul>

                  </Card.Text>
                </Card.Body>
              </Card>

              </div>
             </Row>
            
            <div>
              <GenericCard variant='transperant' className={'border rounded-1 mt-10 custom-blockquote primary'}>
                
            <Row
                key='1'
                className={
                  'py-0 my-0 text-fs-6  lh-xs'
                }
              >  
                <Col lg={3} className="text-center">
                <strong> Minimum Annual Contribution </strong> <br></br>
                $1.00
                </Col>
                <Col lg={3} className="text-center">
                <strong> Maximum Annual Contribution</strong><br></br>
                $9,550.00
                </Col>
                <Col lg={3} className="text-center">
                <strong>Increment</strong> <br></br>$0.01 
                </Col>
                <Col lg={3} className="text-center">
                <strong>Your Election Per-pay-period</strong> Not Contributing
                </Col> 
            </Row>
              </GenericCard>
            </div>
          </GenericCard>
          </Col>
        </Row>
       </Container>

       <Container className={'px-0 py-0 mt-10'}>
        <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <CircledIcon
                  icon={light('tooth')}
                  iconClassName="left-icon"
                  variant="icon-emphasized"
                />
              
                <div className="ms-4">
                  <h5>Dental</h5>
                </div>
                </div>
                <div className="d-flex align-items-center justify-content-end">
            
                </div>
              </div>
              {/* Table head */}
              <Row className={'d-none d-lg-flex mt-0 pb-2'}>
              <Col lg={7} className="py-5"></Col>
              <Col lg={5} className="py-5">Per-pay-period</Col>
              </Row>
              <Row className={'d-none d-lg-flex mt-0 pb-5 pt-5 border-bottom-light-gray-2px'}>
                <Col lg={4}>
                  <div className={'d-flex align-items-center'}>Dental</div>
                </Col>                
                <Col lg={1}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={1} className="text-center">
                  You Only
                </Col>
                <Col lg={2} className="text-center">
                  You + Spouse
                </Col>
                <Col lg={2} className="text-center">
                  You + Child(ren)
                </Col>
                <Col lg={2} className="text-center">
                  You + Family
                </Col>
 
              </Row>

              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Basic Dental Option</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $4.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $9.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $12.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $17.00
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Comprehensive Dental Option</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $10.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $22.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $23.50
                </Col>
                <Col lg={2} className="text-center py-10">
                    $33.50
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Delta Pilots Medical Plan - Dental Option</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $4.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $8.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $9.00
                </Col>
                <Col lg={2} className="text-center py-10">
                    $13.00
                </Col> 
              </Row>         
          
              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>No Coverage</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                     
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $0.00
                </Col>
                <Col lg={2} className="text-center py-10">
                     
                </Col>
                <Col lg={2} className="text-center py-10">
                    
                </Col>
                <Col lg={2} className="text-center py-10">
                     
                </Col> 
              </Row>
            </GenericCard>
            </Col>
            </Row>
             </Container>
             <Container className={'px-0 py-0 mt-10'}>
            <Row className={'mt-8'}>
              <Col className={'col-12'}>
                <GenericCard variant='transperant' className={'border rounded-1'}>
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                      <CircledIcon
                        icon={light('glasses')}
                        iconClassName="left-icon"
                        variant="icon-emphasized"
                      />
                      <div className="ms-4">
                        <h5>Vision</h5>
                      </div>
                    </div>
                        <div className="d-flex align-items-center justify-content-end">
                        </div>
                    </div>

            <Row className={'d-none d-lg-flex mt-0 pb-2'}>
              <Col lg={7} className="py-5"></Col>
              <Col lg={5} className="py-5">Per-pay-period</Col>
              </Row>
              <Row className={'d-none d-lg-flex mt-0 pb-5 pt-5 border-bottom-light-gray-2px'}>
                <Col lg={4}>
                  <div className={'d-flex align-items-center'}>Vision</div>
                </Col>                
                <Col lg={1}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={1} className="text-center">
                  You Only
                </Col>
                <Col lg={2} className="text-center">
                  You + Spouse
                </Col>
                <Col lg={2} className="text-center">
                  You + Child(ren)
                </Col>
                <Col lg={2} className="text-center">
                  You + Family
                </Col>
               </Row>
               <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Vision</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $3.37
                </Col>
                <Col lg={2} className="text-center py-10">
                     $6.39
                </Col>
                <Col lg={2} className="text-center py-10">
                    $6.73
                </Col>
                <Col lg={2} className="text-center py-10">
                     $9.80
                </Col> 
              </Row>
              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={4} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>No Coverage</span></div></div>
                   
                </Col>
                <Col lg={1} className="text-end py-5">
                    
                
                </Col>
                <Col lg={1} className="text-center py-10">
                    $0.00
                </Col>
                <Col lg={2} className="text-center py-10">
                      
                </Col>
                <Col lg={2} className="text-center py-10">
                     
                </Col>
                <Col lg={2} className="text-center py-10">
                      
                </Col> 
              </Row>
            </GenericCard>
            </Col>
            </Row>
        




            <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <CircledIcon
                  icon={light('heart-pulse')}
                  iconClassName="left-icon"
                  variant="icon-emphasized"
                />
              
              <div className="ms-4">
                <h5>Group Variable Universal Life Insurance</h5>
              </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <IconButton
                  variant="secondary-shadow"
                  icon={light('circle-info')}
                  onMouseDown={toggleDetails3}
                  style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                />
                <Label
                  className="d-none d-lg-flex px-4"
                  style={{ color: '#54626A', cursor: 'pointer' }}
                  onMouseDown={toggleDetails3}
                >
                  Benefits Info
                </Label>
              </div>
            </div>
            <Container className={'px-0 py-0 mt-10'}>
            <Row className={`expandable-wrapper ${showDetails3 ? 'open' : ''}`}>
              <div className="w-100 justify-content-center">

              <Card
                bg={'blue'}
                key={'Primary'}
                text={'white'}
                style={{ width: '18rem' }}
                className="bg-primary w-100 mb-12"
              >
                <Card.Body>
                  <Card.Text>
                    <ul>
                      <li>You can elect to have your Delta-paid life insurance (in excess of $50,000) provided through a Group Variable Universal Life (GVUL) insurance program instead of a traditional group term life insurance plan.</li>
                      <li>If you are currently enrolled in GVUL insurance and elect to surrender (terminate) coverage, you will be required to complete a GVUL surrender form at MetLife before your cancellation is processed.</li>
                      <li>Whether electing new GVUL coverage or terminating existing coverage, your election must be completed at MetLife. After your election is received by MetLife, you will be notified when it’s time to complete your required GVUL actions at MetLife.</li>
                      <li>Until your enrollment is completed at MetLife or if you do not complete your enrollment, the full amount of your Delta provided coverage will remain as group term life coverage in 2025. You will not have another GVUL enrollment opportunity until the next open enrollment period.</li>

                    </ul>

                  </Card.Text>
                </Card.Body>
              </Card>

              </div>
            </Row>
              {/* Table head */}
              <Row className={'d-none d-lg-flex mt-0 pb-5 border-bottom-light-gray-2px'}>
                <Col lg={6}>
                  <div className={'d-flex align-items-center'}>
                  Group Variable Universal Life Insurance</div>
                </Col>                
                <Col lg={3}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={3} className="text-center">
                Per-pay-period
                </Col>
 
 
              </Row>

              <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={6} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span> MetLife GVUL</span></div></div>
                 </Col>
                <Col lg={3} className="text-end py-5">
                 </Col>
                <Col lg={3} className="text-center bg-primary text-white py-10">
                    $0.00
                </Col>
              </Row>
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={6} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>MetLife GVUL Surrender</span></div></div>
                  <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>* This option requires actions at MetLife.</span></div></div>                
                 </Col>
                <Col lg={3} className="text-end py-5">
                 </Col>
                <Col lg={3} className="py-10 text-center">
                    $0.00
                </Col>
              </Row>
               
              <div className={'d-none d-lg-block mt-10'}>
            <Blockquote variant="primary">
              <div className={'mt-2 text-ligther-grey'}>
              * After your election is received by MetLife, you will be notified when it’s time to complete your required GVUL actions.
              </div>
              <div className='mt-2'>
              Until your actions are completed at MetLife or if you do not complete your required actions, your current coverage elections will remain in effect. You will not have another opportunity to change your GVUL coverage (enroll or surrender) until the next open enrollment period
              </div>
            </Blockquote>
          </div>

            </Container>
          </GenericCard>
          
        </Col>
      </Row>



      <Row className={'mt-8'}>
              <Col className={'col-12'}>
                <GenericCard variant='transperant' className={'border rounded-1'}>
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                      <CircledIcon
                        icon={light('heart-pulse')}
                        iconClassName="left-icon"
                        variant="icon-emphasized"
                      />
                      <div className="ms-4">
                        <h5>Basic Life Insurance</h5>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <IconButton
                        variant="secondary-shadow"
                        icon={light('circle-info')}
                        onMouseDown={toggleDetails4}
                        style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                      />
                      <Label
                        className="d-none d-lg-flex px-4"
                        style={{ color: '#54626A', cursor: 'pointer' }}
                        onMouseDown={toggleDetails4}
                      >
                        Benefits Info
                      </Label>
                    </div>
                    </div>

                    <Row className={`mt-8 expandable-wrapper ${showDetails4 ? 'open' : ''}`}>
              <div className="w-100 justify-content-center">

              <Card
                bg={'blue'}
                key={'Primary'}
                text={'white'}
                style={{ width: '18rem' }}
                className="bg-primary w-100 mb-12"
              >
                <Card.Body>
                  <Card.Text>
                    <ul>
                      <li> You can elect to have your Delta-paid life insurance (in excess of $50,000) provided through a Group Variable Universal Life (GVUL) insurance program instead of a traditional group term life insurance plan.</li>
                      <li>If you are currently enrolled in GVUL insurance and elect to surrender (terminate) coverage, you will be required to complete a GVUL surrender form at MetLife before your cancellation is processed. Once processed, your GVUL coverage amount will be converted to basic life insurance.</li>
                      <li> You can elect to have your Delta-paid life insurance (in excess of $50,000) provided through a Group Variable Universal Life (GVUL) insurance program instead of a traditional group term life insurance plan.</li>
                      <li>  Your election can’t be changed again until the next open enrollment period, and you will be subject to EOI if you had previously elected the flat $50,000 basic life option.</li>
                      <li> You should name a beneficiary online on the MetLife site. </li>
                      
                    </ul>

                  </Card.Text>
                </Card.Body>
              </Card>

              </div>
            </Row>
              <Row className={'d-none d-lg-flex mt-10 pb-5 pt-5 border-bottom-light-gray-2px'}>
                <Col lg={6}>
                  <div className={'d-flex align-items-center'}>Basic Life Insurance</div>
                </Col>                
                <Col lg={3}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={3} className="text-center">
                Per-pay-period
                </Col>
          
               </Row>
               <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={6} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Coverage (Insurance Amount: $50,000)</span></div></div>
                   
                </Col>
                <Col lg={3} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                
                <Col lg={3} className="text-center py-10 bg-primary text-white">
                     $9.80
                </Col> 
              </Row>
            </GenericCard>
            </Col>
            </Row>
            <Row className={'mt-8'}>
              <Col className={'col-12'}>
                <GenericCard variant='transperant' className={'border rounded-1'}>
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                      <CircledIcon
                        icon={light('heart-pulse')}
                        iconClassName="left-icon"
                        variant="icon-emphasized"
                      />
                      <div className="ms-4">
                        <h5>Optional Life Insurance</h5>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <IconButton
                        variant="secondary-shadow"
                        icon={light('circle-info')}
                        onMouseDown={toggleDetails5}
                        style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                      />
                      <Label
                        className="d-none d-lg-flex px-4"
                        style={{ color: '#54626A', cursor: 'pointer' }}
                        onMouseDown={toggleDetails5}
                      >
                        Benefits Info
                      </Label>
                    </div>
                    </div>
                    <Row className={`mt-8 expandable-wrapper ${showDetails5 ? 'open' : ''}`}>
                    <div className="w-100 justify-content-center">

                      <Card
                        bg={'blue'}
                        key={'Primary'}
                        text={'white'}
                        style={{ width: '18rem' }}
                        className="bg-primary w-100 mb-12"
                      >
                        <Card.Body>
                          <Card.Text>
                            <ul>
                              <li> If you have used tobacco within the past 12 months, you must select the tobacco user rate.</li>
                              <li> If you are not in active employment status, coverage may be added or increased only upon your return to active status. Coverage cannot be added or increased at or after retirement.</li>
                              <li> If you are currently enrolled, you may only increase coverage by one level without showing Evidence of Insurability (EOI).</li>
                              <li> New hires may elect up to a maximum coverage level of $1,500,000 without showing EOI. </li>
                              <li> If you are not a new hire and you are not currently enrolled, you must show EOI for any level of coverage you elect. </li>
                              <li> If you are required to show EOI, you will be directed to complete a more extensive ‘MetLife Statement of Health’ online or you may request a paper form from the My Delta Service Center (MDSC). Until your request is approved (or if denied), or if you do not complete the MetLife Statement of Health form within 30 days of receipt of the form, you will be covered under and pay premiums for the highest level of coverage for which you are eligible without approval.</li>
                              <li> Premiums are based on your age; therefore, your birthday may cause your premiums to increase during the year. That means you may enroll at one premium at this time and have a change to your premium on your birthday if your age crosses a five-year age bracket (your new age will end in a zero or a five).</li>
                              <li> You can drop or decrease your Optional Life Insurance mid-year outside of Open Enrollment. From Benefits Direct click Life Events from the menu and select “Life Insurance Drop/Decrease”.</li>
                              <li> You should name a beneficiary online on the MetLife site.</li>
                              
                            </ul>

                  </Card.Text>
                </Card.Body>
              </Card>

              </div>
            </Row>        
                <Row className={'d-none d-lg-flex mt-0 pb-2'}>
                  <Col lg={8} className="py-5"></Col>
                  <Col lg={4} className="py-5 text-center">Per-pay-period</Col>
                  </Row>
                  <Row className={'d-none d-lg-flex mt-0 pb-5 pt-5 border-bottom-light-gray-2px'}>
                    <Col lg={7}>
                      <div className={'d-flex align-items-center'}>Optional Life Insurance</div>
                    </Col>                
                    <Col lg={3}>
                      <div className={'d-flex'}>	NON-TOBACCO USER</div>
                    </Col>
                    <Col lg={2} className="text-center">
                    TOBACCO USER
                    </Col>
       
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$25,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $4.00
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $5.01
                    </Col>
 
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$50,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $8.00
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $10.03
                    </Col>
 
                  </Row>

                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$75,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $12.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $15.04
                    </Col>
 
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$100,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $16.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $20.05
                    </Col>
                  </Row>

                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$125,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $20.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $25.06
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$150,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $24.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $30.08
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$175,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $28.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $35.09
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$200,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $32.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $40.10
                    </Col>
                  </Row>       
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$225,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $36.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $45.11
                    </Col>
                  </Row> 
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$250,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $40.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $50.13
                    </Col>
                  </Row>          
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$275,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $44.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $55.14
                    </Col>
                  </Row>  
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$300,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $48.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $60.15
                    </Col>
                  </Row>          
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$325,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $52.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $65.16
                    </Col>
                  </Row>       
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$350,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $56.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $70.18
                    </Col>
                  </Row>


                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$375,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $60.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $35.09
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$400,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $64.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $80.20
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$425,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $68.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $85.21
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$450,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $72.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $90.23
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$475,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $76.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $95.24
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$500,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $80.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $100.25
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$525,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $84.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $105.26
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$550,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $88.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $110.28
                    </Col>
                  </Row> 
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$575,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $92.00	
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $115.29
                    </Col>
                  </Row>
                      <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>No Coverage</span></div></div>
                      
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        
                    
                    </Col>
                    <Col lg={3} className="text-center py-10 bg-primary text-white">
                        $0.00
                    </Col>
                    <Col lg={2} className="text-center py-10">
                          
                    </Col>
      
                  </Row>  
              <div className={'d-none d-lg-block mt-10'}>
                <Blockquote variant="primary">
    
                  <div className='mt-2'>
                    <ul>
                      <li> * This option may require completion of a Statement of Health form.</li>
                      <li>Evidence of Insurability (EOI) – Proof of Good Health – may be required if you elect this level of coverage. After you make your election, if applicable, you will be directed to an EOI questionnaire. If after answering this EOI questionnaire you are denied the coverage or coverage level you requested, you will be required to complete the more extensive ‘MetLife Statement of Health Form’. You must complete the MetLife Statement of Health online during your enrollment period; however, if you are unable to complete the online form, a paper version of the MetLife Statement of Health form may be mailed to you upon request to the My Delta Service Center (MDSC). You must request a paper MetLife EOI form within 30 days following your enrollment period. You must return the paper 'Statement of Health Form' to MetLife within 30 days from the date you receive the paper form.</li>
                      <li>Until your request is approved (or if denied), or if you do not complete the MetLife Statement of Health form within 30 days of your enrollment period, you will be covered under and pay premiums for the highest level of coverage for which you are eligible without approval.</li>
                    </ul>
                  </div>
                </Blockquote>
              </div>    
                </GenericCard>
              </Col>
            </Row>

            <Row className={'mt-8'}>
            <Col className={'col-12'}>
              <GenericCard variant='transperant' className={'border rounded-1'}>
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <div className="d-flex">
                    <CircledIcon
                      icon={light('heart-pulse')}
                      iconClassName="left-icon"
                      variant="icon-emphasized"
                    />
              
                      <div className="ms-4">
                        <h4>Spouse Life Insurance</h4>
                      </div>
                      </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <IconButton
                        variant="secondary-shadow"
                        icon={light('circle-info')}
                        onMouseDown={toggleDetails6}
                        style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                      />
                      <Label
                        className="d-none d-lg-flex px-4"
                        style={{ color: '#54626A', cursor: 'pointer' }}
                        onMouseDown={toggleDetails6}
                      >
                        Benefits Info
                      </Label>
                    </div>
                  </div>
                  <Container className={'px-0 py-0 mt-10'}>
                  <Row className={`expandable-wrapper ${showDetails6 ? 'open' : ''}`}>
                    <div className="w-100 justify-content-center">

                    <Card
                      bg={'blue'}
                      key={'Primary'}
                      text={'white'}
                      style={{ width: '18rem' }}
                      className="bg-primary w-100 mb-12"
                    >
                      <Card.Body>
                        <Card.Text>
                          <ul>
                            <li>If your spouse has used tobacco within the past 12 months, you must select the tobacco user rate.</li>
                            <li>If you are not in active employment status, coverage may be added or increased only upon your return to active status. Coverage cannot be added or increased at or after retirement.</li>
                            <li>New hires may elect up to a maximum coverage level of $20,000 without showing EOI. </li>
                            <li>If you are NOT currently enrolled or if you would like to increase your coverage, you must provide EOI for any level of coverage you elect. 
                            </li>
                            <li>If your spouse is required to show EOI, you will be directed to complete a more extensive ‘MetLife Statement of Health’ online or you may request a paper form from the My Delta Service Center (MDSC). Until EOI is approved for your spouse (or if denied), or if your spouse does not complete the MetLife Statement of Health Form within 30 days of receipt of the form, your spouse will be covered under and you will pay premiums for the highest level of coverage for which your spouse is eligible without approval.
                            </li>
                            <li>A spouse’s eligibility is based on his/her dependent status on the date of death.
                            </li>
                            <li>As the employee, you are automatically the beneficiary for this insurance. No beneficiary designation is required.</li>
                          </ul>

                        </Card.Text>
                      </Card.Body>
                    </Card>

                    </div>
                  </Row>
                    {/* Table head */}

                    <Row className={'d-none d-lg-flex mt-0 pb-2'}>
                  <Col lg={8} className="py-5"></Col>
                  <Col lg={4} className="py-5 text-center">Per-pay-period</Col>
                  </Row>
                  <Row className={'d-none d-lg-flex mt-0 pb-5 pt-5 border-bottom-light-gray-2px'}>
                    <Col lg={7}>
                      <div className={'d-flex align-items-center'}>Spouse Life Insurance</div>
                    </Col>                
                    <Col lg={3}>
                      <div className={'d-flex'}>	NON-TOBACCO USER</div>
                    </Col>
                    <Col lg={2} className="text-center">
                    TOBACCO USER
                    </Col>
       
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$20,000</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $3.04
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $3.70
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$30,000</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $4.56
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $5.55
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$50,000</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $7.60
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $9.25
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$75,000</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $11.40                   </Col>
                    <Col lg={2} className="text-center py-10">
                    $13.88
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$100,000</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10 bg-primary text-white">
                    $15.20
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $18.50
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$125,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $19.00
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $23.13
                    </Col>
 
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$150,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $22.80
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $27.75
                    </Col>
                  </Row>
                   
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$175,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $26.60
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $32.38
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$200,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $30.40
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $37.00
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$225,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $34.20
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $41.63
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$250,000</span></div></div>
                      <div className="p-0 row"><div className="fw-normal text-caption lh-xxs text-danger"><span>This option may require completion of a Statement of Health form. *</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $38.00
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $47.25
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>No Coverage</span></div></div>
                      
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        
                    
                    </Col>
                    <Col lg={3} className="text-center py-10 ">
                        $0.00
                    </Col>
                    <Col lg={2} className="text-center py-10">
                          
                    </Col>
      
                  </Row>  
 
 
            </Container>
          </GenericCard>
        </Col>
      </Row>
            
      <Row className={'mt-8'}>
            <Col className={'col-12'}>
              <GenericCard variant='transperant' className={'border rounded-1'}>
                <div className="w-100 d-flex justify-content-between align-items-center">
                  <div className="d-flex">
                    <CircledIcon
                      icon={light('heart-pulse')}
                      iconClassName="left-icon"
                      variant="icon-emphasized"
                    />
              
                      <div className="ms-4">
                        <h4>Group Accident Insurance</h4>
                      </div>
                      </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <IconButton
                        variant="secondary-shadow"
                        icon={light('circle-info')}
                        onMouseDown={toggleDetails7}
                        style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                      />
                      <Label
                        className="d-none d-lg-flex px-4"
                        style={{ color: '#54626A', cursor: 'pointer' }}
                        onMouseDown={toggleDetails7}
                      >
                        Benefits Info
                      </Label>
                    </div>
                  </div>
                  <Container className={'px-0 py-0 mt-10'}>
                  <Row className={`expandable-wrapper ${showDetails7 ? 'open' : ''}`}>
                    <div className="w-100 justify-content-center">

                    <Card
                      bg={'blue'}
                      key={'Primary'}
                      text={'white'}
                      style={{ width: '18rem' }}
                      className="bg-primary w-100 mb-12"
                    >
                      <Card.Body>
                        <Card.Text>
                          <ul>
                            <li>If you are not in active employment status, coverage may be added or increased only upon your return to active status. Coverage cannot be added or increased at or after retirement.</li>
                            <li>In the event you and your spouse (or ex-spouse) have children who are eligible for group accident insurance, only one parent (or stepparent) may cover the child.</li>
                            <li>Even if a dependent is covered by more than one employee (or retiree), only one claim can be paid.</li>
                            <li>A dependent’s eligibility is based on his/her dependent status on the date of death.</li>
                            <li>You should name a beneficiary online on the ACE CHUBB site.</li>
                          </ul>

                        </Card.Text>
                      </Card.Body>
                    </Card>

                    </div>
                  </Row>
                    {/* Table head */}

                    <Row className={'d-none d-lg-flex mt-0 pb-2'}>
                  <Col lg={8} className="py-5"></Col>
                  <Col lg={4} className="py-5 text-center">Per-pay-period</Col>
                  </Row>
                  <Row className={'d-none d-lg-flex mt-0 pb-5 pt-5 border-bottom-light-gray-2px'}>
                    <Col lg={7}>
                      <div className={'d-flex align-items-center'}>Group Accident Insurance</div>
                    </Col>                
                    <Col lg={3}>
                      <div className={'d-flex'}>You Only</div>
                    </Col>
                    <Col lg={2} className="text-center">
                      <div className={'d-flex'}>You + Family</div>
                    </Col>
       
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$25,000</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $0.31
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $0.45
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$50,000</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $0.63
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $0.89
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$75,000</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $0.94
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $1.33
                    </Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$100,000</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10">
                    $1.25</Col>
                    <Col lg={2} className="text-center py-10">
                    $1.78</Col>
                  </Row>
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$125,000</span></div></div>
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                    
                    </Col>
                    <Col lg={3} className="text-center py-10 bg-primary text-white">
                    $15.20
                    </Col>
                    <Col lg={2} className="text-center py-10">
                    $18.50
                    </Col>
                  </Row>
                      
                  <Row
                    key='1'
                    className={
                      'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                    }
                  >
                    <Col lg={6} className="py-5">
                      <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>No Coverage</span></div></div>
                      
                    </Col>
                    <Col lg={1} className="text-end py-5">
                        
                    
                    </Col>
                    <Col lg={3} className="text-center py-10 ">
                        $0.00
                    </Col>
                    <Col lg={2} className="text-center py-10">
                          
                    </Col>
      
                  </Row>  
 
 
            </Container>
          </GenericCard>
        </Col>
      </Row>
      <Row className={'mt-8'}>
              <Col className={'col-12'}>
                <GenericCard variant='transperant' className={'border rounded-1'}>
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                      <CircledIcon
                        icon={light('heart-pulse')}
                        iconClassName="left-icon"
                        variant="icon-emphasized"
                      />
                      <div className="ms-4">
                        <h5>Private Pilots Accident Insurance</h5>
                      </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <IconButton
                        variant="secondary-shadow"
                        icon={light('circle-info')}
                        onMouseDown={toggleDetails8}
                        style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                      />
                      <Label
                        className="d-none d-lg-flex px-4"
                        style={{ color: '#54626A', cursor: 'pointer' }}
                        onMouseDown={toggleDetails8}
                      >
                        Benefits Info
                      </Label>
                    </div>
                    </div>

                    <Row className={`mt-8 expandable-wrapper ${showDetails8 ? 'open' : ''}`}>
              <div className="w-100 justify-content-center">

              <Card
                bg={'blue'}
                key={'Primary'}
                text={'white'}
                style={{ width: '18rem' }}
                className="bg-primary w-100 mb-12"
              >
                <Card.Body>
                  <Card.Text>
                    <ul>
                      <li> If you are not in active employment status, coverage may be added or increased only upon your return to active status. Coverage cannot be added or increased at or after retirement.</li>
                      <li> Private Pilots Accident Insurance is only available if you have also elected Group Accident Insurance.</li>
                      <li> Your coverage amount for Private Pilots Accident Insurance may not exceed 
                        (a) fifty (50) times the number of logbook pilot hours, rounded to the next $15,000 increment or
                        (b) your coverage amount for Group Accident Insurance, whichever is less.</li>
                        <li> Logbook pilot hours are verified at the time of claim. Premiums paid for coverage that exceeds fifty (50) times the number of logbook pilot hours, rounded to the next $15,000 increment, are non-refundable.</li>
                        <li> You should name a beneficiary online on the ACE CHUBB site.</li>
                                              
                    </ul>

                  </Card.Text>
                </Card.Body>
              </Card>

              </div>
            </Row>
              <Row className={'d-none d-lg-flex mt-10 pb-5 pt-5 border-bottom-light-gray-2px'}>
                <Col lg={6}>
                  <div className={'d-flex align-items-center'}>Private Pilots Accident Insurance</div>
                </Col>                
                <Col lg={3}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={3} className="text-center">
                Per-pay-period
                </Col>
          
               </Row>
               <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={6} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>$15,000</span></div></div>
                   
                </Col>
                <Col lg={3} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                
                <Col lg={3} className="text-center py-10">
                     $0.41
                </Col> 
              </Row>
               <Row
                key='1'
                className={
                  'py-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={6} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>Coverage (Insurance Amount: $50,000)</span></div></div>
                   
                </Col>
                <Col lg={3} className="text-end py-5">
                    <PopoverWithLinks
                      linksData={[
                        {
                          linkHeader: 'PDF Document',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Phone : 877 -912-1820',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                        {
                          linkHeader: 'Visit Site',
                          route: ``,
                          rightIcon: light('chevron-right'),
                          modal: false,
                        },
                      ]}
                    />
                
                </Col>
                
                <Col lg={3} className="text-center py-10 bg-primary text-white">
                     $0.00
                </Col> 
              </Row>
            </GenericCard>
            </Col>
            </Row>


            <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
  
            <Row className={'mt-0'}>
              <Col className={'col-12'}>
                
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                      <CircledIcon
                        icon={light('heart-pulse')}
                        iconClassName="left-icon"
                        variant="icon-emphasized"
                      />
                    
                    <div className="ms-4">
                      <h5>Dependent Care Flexible Spending Account</h5>
                    </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <IconButton
                        variant="secondary-shadow"
                        icon={light('circle-info')}
                        onMouseDown={toggleDetails9}
                        style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                      />
                      <Label
                        className="d-none d-lg-flex px-4"
                        style={{ color: '#54626A', cursor: 'pointer' }}
                        onMouseDown={toggleDetails9}
                      >
                        Benefits Info
                      </Label>
                    </div>
                  </div>
                  <Row className={`expandable-wrapper mt-10 ${showDetails9 ? 'open' : ''}`}>
                    <div className="w-100 justify-content-center">

                    <Card
                      bg={'blue'}
                      key={'Primary'}
                      text={'white'}
                      style={{ width: '18rem' }}
                      className="bg-primary w-100 mb-12"
                    >
                      <Card.Body>
                        <Card.Text>
                          <ul>
                            <li>In 2025, you may contribute up to $5,000 pre-tax to pay for certain eligible dependent care expenses. Qualified work-related day care expenses are eligible for reimbursement only for children or other eligible dependents who are under 13 and qualify as your tax dependent.</li>
                            <li>For additional information and resources for childcare visit Care.com.</li>
                          </ul>

                        </Card.Text>
                      </Card.Body>
                    </Card>

                    </div>
                  </Row>
            
            <div>
              <GenericCard variant='transperant' className={'border rounded-1 custom-blockquote primary'}>
                
                  <Row
                      key='1'
                      className={
                        'py-0 my-0 text-fs-6  lh-xs'
                      }
                    >  
                      <Col lg={3} className="text-center">
                      <strong> Minimum Annual Contribution </strong> <br></br>
                      $120.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong> Maximum Annual Contribution</strong><br></br>
                      $5,000.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong>Increment</strong> <br></br>$1.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong>Your Election Per-pay-period</strong> Not Contributing
                      </Col> 
                 </Row>
              </GenericCard>
            </div>
          
              </Col>
            </Row>
           
          </GenericCard>
        </Col>
      </Row>

      <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
  
            <Row className={'mt-0'}>
              <Col className={'col-12'}>
                
                  <div className="w-100 d-flex justify-content-between align-items-center">
                    <div className="d-flex">
                      <CircledIcon
                        icon={light('heart-pulse')}
                        iconClassName="left-icon"
                        variant="icon-emphasized"
                      />
                    
                    <div className="ms-4">
                      <h5>Limited Purpose Flexible Spending Account</h5>
                    </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <IconButton
                        variant="secondary-shadow"
                        icon={light('circle-info')}
                        onMouseDown={toggleDetails10}
                        style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                      />
                      <Label
                        className="d-none d-lg-flex px-4"
                        style={{ color: '#54626A', cursor: 'pointer' }}
                        onMouseDown={toggleDetails10}
                      >
                        Benefits Info
                      </Label>
                    </div>
                  </div>
                  <Row className={`expandable-wrapper mt-10 ${showDetails10 ? 'open' : ''}`}>
                    <div className="w-100 justify-content-center">

                    <Card
                      bg={'blue'}
                      key={'Primary'}
                      text={'white'}
                      style={{ width: '18rem' }}
                      className="bg-primary w-100 mb-12"
                    >
                      <Card.Body>
                        <Card.Text>
                          <ul>
                            <li>If you enroll in a high deductible medical option and want to contribute to Delta’s Healthcare FSA, your FSA will be a Limited Purpose FSA.</li>
                            <li>In 2025, you may contribute up to $3,300 pre-tax to pay for certain eligible healthcare expenses that are not covered by other insurance plans.</li>
                          </ul>

                        </Card.Text>
                      </Card.Body>
                    </Card>

                    </div>
                  </Row>
            
            <div>
              <GenericCard variant='transperant' className={'border rounded-1 custom-blockquote primary'}>
                
                  <Row
                      key='1'
                      className={
                        'py-0 my-0 text-fs-6  lh-xs'
                      }
                    >  
                      <Col lg={3} className="text-center">
                      <strong> Minimum Annual Contribution </strong> <br></br>
                      $120.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong> Maximum Annual Contribution</strong><br></br>
                      $3,200.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong>Increment</strong> <br></br>$1.00
                      </Col>
                      <Col lg={3} className="text-center">
                      <strong>Your Election Per-pay-period</strong> Not Contributing
                      </Col> 
                 </Row>
              </GenericCard>
            </div>
          
              </Col>
            </Row>
           
          </GenericCard>
        </Col>
      </Row>

      <Row className={'mt-8'}>
        <Col className={'col-12'}>
          <GenericCard variant='transperant' className={'border rounded-1'}>
            <div className="w-100 d-flex justify-content-between align-items-center">
              <div className="d-flex">
                <CircledIcon
                  icon={light('heart-pulse')}
                  iconClassName="left-icon"
                  variant="icon-emphasized"
                />
              
              <div className="ms-4">
                <h5>Long-Term Disability Coverage</h5>
              </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <IconButton
                  variant="secondary-shadow"
                  icon={light('circle-info')}
                  onMouseDown={toggleDetails11}
                  style={{ backgroundColor: '#9DB4C04D', boxShadow: 'none' }}
                />
                <Label
                  className="d-none d-lg-flex px-4"
                  style={{ color: '#54626A', cursor: 'pointer' }}
                  onMouseDown={toggleDetails11}
                >
                  Benefits Info
                </Label>
              </div>
            </div>
            <Container className={'px-0 py-0 mt-10'}>
            <Row className={`expandable-wrapper ${showDetails11 ? 'open' : ''}`}>
              <div className="w-100 justify-content-center">

              <Card
                bg={'blue'}
                key={'Primary'}
                text={'white'}
                style={{ width: '18rem' }}
                className="bg-primary w-100 mb-12"
              >
                <Card.Body>
                  <Card.Text>
                    <ul>
                      <li>If you are not in active employment status, coverage may be added only upon your return to active status.</li>
                      <li>Premiums are based on your age; therefore, your birthday may cause your premiums to increase during the year. That means you may enroll at one premium at this time and have a change to your premium on your birthday if your age crosses a five-year age bracket (your new age will end in a zero or a five).</li>

                    </ul>

                  </Card.Text>
                </Card.Body>
              </Card>

              </div>
            </Row>
              {/* Table head */}
              <Row className={'d-none d-lg-flex mt-0 pb-5 border-bottom-light-gray-2px'}>
                <Col lg={6}>
                  <div className={'d-flex align-items-center'}>Long-Term Disability Coverage</div>
                </Col>                
                <Col lg={3}>
                  <div className={'d-flex'}></div>
                </Col>
                <Col lg={3} className="text-center">
                Per-pay-period
                </Col>
          
 
              </Row>

 
              <Row
                key='1'
                className={
                  'py-0 my-0 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'
                }
              >
                <Col lg={6} className="py-5">
                  <div className="m-0 p-0 row"><div className="p-0 fw-normal text-sub1 lh-xs"><span>50% Coverage (Average Pre-Disability Earnings: $0)</span></div></div>
                 </Col>
                <Col lg={3} className="text-end py-5">
                    <PopoverWithLinks
                          linksData={[
                            {
                              linkHeader: 'PDF Document',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Phone : 877 -912-1820',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                            {
                              linkHeader: 'Visit Site',
                              route: ``,
                              rightIcon: light('chevron-right'),
                              modal: false,
                            },
                          ]}
                        />
                
                </Col>
                <Col lg={3} className="py-10 text-center bg-primary text-white">
                    $0.00
                </Col>
              </Row>
 
 
            </Container>
          </GenericCard>
        </Col>
      </Row>               

            
    
    
    </Container>




    </Container>
  )
}

export default AllBenefits